import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import { VidyardVideoPlayerProps } from './VidyardVideo.d'

const VidyardVideoPlayer = ({
  vidyardId,
  display = 'lightbox',
  classes = '',
  disableAnalytics = '0'
}: VidyardVideoPlayerProps) => {
  const ref = useRef<any | null>(null)
  useEffect(() => {
    if (typeof window !== 'undefined' && vidyardId) {
      ;(async () => {
        // @ts-ignore - Typescript defs missing for @vidyard/embed-code
        const vidyardEmbed = await import('@vidyard/embed-code')
        if (vidyardEmbed.api && ref.current) {
          vidyardEmbed.api.renderDOMPlayers(ref.current)
        }
      })()
    }
  }, [])

  const vidyardClasses = classNames(classes, {
    'relative mt-5 mb-12 flex flex-wrap w-full':
      classes === '' && display === 'lightbox',
    'h-full w-full relative': classes === '' && display === 'inline'
  })

  return (
    <>
      {display === 'lightbox' && (
        <div
          className={vidyardClasses}
          data-testid='vidyard-video-player'
          ref={ref}
        >
          <div className='mx-auto w-full overflow-hidden block h-auto relative text-center max-w-full'>
            <img
              loading='lazy'
              className='vidyard-player-embed w-full m-auto block'
              data-uuid={vidyardId}
              data-v='4'
              data-autoplay='1'
              data-type='lightbox'
              alt={`Vidyard Video ${vidyardId}`}
            />
          </div>
        </div>
      )}
      {display === 'inline' && (
        <div
          className={vidyardClasses}
          data-testid='vidyard-video-player'
          ref={ref}
        >
          <img
            loading='lazy'
            className='vidyard-player-embed w-full m-auto hidden'
            // src={`https://play.vidyard.com/${vidyardId}.jpg`}
            alt={`Vidyard Video ${vidyardId}`}
            data-uuid={vidyardId}
            data-v='4'
            data-disable_analytics={disableAnalytics}
            data-type='inline'
          />
        </div>
      )}
    </>
  )
}

export default VidyardVideoPlayer
